<template>
  <client-only>
    <div
      v-show="allowUseMember && isMembersUserInfoNull && isRussia"
      :class="membershipClassName"
    >
      <div class="membership-cards" @click="jumpPrivilege">
        <div class="cards-title">
          <div class="cards-title-name">
            <template v-if="locaoMembers.levelCode === 0">
              {{ $t('member.membership_level1') }}
            </template>
            <template v-else-if="levelLogo">
              <img
                class="level-logo"
                :src="require(`@/assets/images/member/${levelLogo}.png`)"
              />
            </template>
          </div>
          <div class="cards-title-privilege">
            <div class="cards-score-lt">
              <h2>
                <template v-if="isMaxBoundary">
                  <span>{{ locaoMembers.spendingExp }}</span>
                </template>
                <template v-else>
                  <span>{{ locaoMembers.spendingExp }}</span
                  ><em>/</em><b>{{ locaoMembers.endSpendingExp }}</b>
                </template>
              </h2>
            </div>
            <van-icon class="right-icon" name="arrow" :size="14" />
          </div>
        </div>
        <div class="cards-score">
          <div v-if="!isMaxBoundary" class="cards-score-rt">
            {{ nextLevel }}
          </div>
        </div>
        <!-- 进度条 start -->
        <div class="cards-speed-progress">
          <div :style="{ width: progressBar }" class="fill-progress"></div>
        </div>
        <!-- 进度条 end -->
        <div
          class="member-benefits"
          v-if="localCardSwipes && localCardSwipes.length"
        >
          <div :class="['roll', isMaxBoundary ? 'boundary-roll' : '']">
            <van-swipe
              :autoplay="1500"
              :touchable="false"
              :show-indicators="false"
              class="roll-items-swipe"
              vertical
            >
              <van-swipe-item
                :key="index"
                v-for="(item, index) in localCardSwipes"
                class="roll-custom-items-swipe"
              >
                <div class="roll-items">
                  <img
                    class="roll-items-icon"
                    :src="require(`@/assets/images/member/${item.icon}.png`)"
                  />
                  <p>{{ item.massage }}</p>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
      </div>
    </div>
  </client-only>
</template>

<script>
  import { mapState, mapGetters } from 'vuex'
  import isEmpty from 'lodash/isEmpty'
  import { storage } from '@/utils/storage'
  import { tryToNative, hideAppSidebar } from '@/utils/native'
  import { urlAddNotNullParams } from '@/utils/url'

  export default {
    name: 'membership-module',
    data() {
      return {}
    },
    computed: {
      ...mapState([
        'members',
        'region',
        'allowUseMember',
        'isApp',
        'isDesktop',
      ]),
      ...mapGetters(['appBaseUrl', 'displayLayout', 'isNewLayout']),

      // 右侧菜单的content class
      membershipClassName() {
        let classNames = ['membership-cards-center', this.displayLayout]
        let bindAppClass = this.isApp ? 'membership-cards-center-app' : ''
        let newVersionClass = this.isNewLayout ? 'new-version' : ''
        return classNames.concat(bindAppClass, newVersionClass)
      },

      // 涉及到三方支付跳转、丢失VUEX的值、做兜底方案
      locaoMembers() {
        const vuexInfo = this.members.userInfo
        let localInfo = {}

        try {
          localInfo = storage.get('membersUserInfo') || {}
        } catch (err) {
          // eslint-disable-next-line
          console.log(err)
        }

        const result = !isEmpty(vuexInfo) ? vuexInfo : localInfo

        return result || {}
      },

      // 涉及到三方支付跳转、丢失VUEX的值、做兜底方案
      localCardSwipes() {
        const vuexCardSwipes = this.members.cardSwipes || []
        const localCardSwipes = storage.get('membersCardSwipe') || []

        const result = !isEmpty(vuexCardSwipes)
          ? vuexCardSwipes
          : localCardSwipes

        return result
      },
      // 判断是否有用户信息
      isMembersUserInfoNull() {
        return !isEmpty(this.locaoMembers)
      },

      // 俄罗斯不显示会员卡片
      isRussia() {
        return this.region !== 'ru'
      },
      // 等级的icon
      levelLogo() {
        const userInfo = this.locaoMembers

        if (userInfo && userInfo.levelCode && userInfo.levelCode > 0) {
          const _levelCode = userInfo.levelCode
          return userInfo.levelCode <= 6
            ? `card_v${_levelCode}`
            : `card_sv${_levelCode - 6}`
        }
        return ''
      },
      // 进度条
      progressBar() {
        let userInfo = this.locaoMembers
        const { endSpendingExp = 0, spendingExp = 0, levelCode } = userInfo

        // 等级为 SVIP5 进度为满值
        if (levelCode === 11) return '100%'
        // 如果当前会员结束的消费值 为0 、证明数据错误
        if (endSpendingExp === 0) {
          return '0'
        }

        return `${Math.round((spendingExp / endSpendingExp) * 100)}%`
      },
      // 下一个等级
      nextLevel() {
        let userInfo = this.locaoMembers
        let { levelCode = 0 } = userInfo

        if (levelCode !== 0 && levelCode < 6) {
          return `VIP ${++levelCode}`
        }

        if (levelCode !== 0 && levelCode >= 6) {
          return `SVIP ${levelCode - 5}`
        }

        return 'VIP 1'
      },

      // 最高等级的边界限制
      isMaxBoundary() {
        let userInfo = this.locaoMembers

        // 服务器规定最高等级 11级 SVIP5
        if (userInfo && userInfo.levelCode && userInfo.levelCode === 11) {
          // 当前用户消费值大于 最高等级的消费值 视为边界状态
          return userInfo.spendingExp >= userInfo.startSpendingExp
        }
        return false
      },
    },
    methods: {
      // 跳转会员特权页面
      jumpPrivilege() {
        const { query = {} } = this.$route
        tryToNative({
          url: urlAddNotNullParams(
            `${this.appBaseUrl}/membersPrivilege`,
            query
          ),
          params: JSON.stringify({
            requireLogin: true,
          }),
        })
          .then(() => {
            hideAppSidebar()
          })
          .catch(() => {
            this.$router_push({
              path: '/membersPrivilege',
              query,
            })
          })
      },
    },
  }
</script>

<style scoped lang="scss" src="./index.scss"></style>
<style scoped lang="scss">
  @media screen and (min-device-width: 1080px) {
    @import './index_pc.scss';
  }
</style>
